/**
 * Take the Operator to the row that blocked them.
 *
 * A blocked action (Generate Quote Summary, notify crew) reveals its inline
 * banners and stops. In a gear list several screens tall the offending row is
 * usually off-screen, so the button appears to do nothing — the notice exists,
 * it is just somewhere the Operator is not looking.
 *
 * Only `error` banners are targets: a warning is advisory and never blocked
 * anything, so scrolling to one would move the page for a reason the Operator
 * did not ask about.
 */

/** Instant: a smooth scroll is hand-written motion, and this one is not on
 *  DESIGN.md's list of sanctioned exceptions (DESIGN-SYSTEM.md, Motion). */
const SCROLL: ScrollIntoViewOptions = { block: "center" };

export function scrollToFirstBlockingNotice(
  root: ParentNode = document,
): boolean {
  const notice = root.querySelector<HTMLElement>(
    '[data-inline-banner="error"]',
  );
  if (!notice) return false;
  notice.scrollIntoView(SCROLL);
  return true;
}

/**
 * Run it after the render that reveals the notices — the click that blocks is
 * the same tick that flips validation on, so the element does not exist yet.
 */
export function scrollToFirstBlockingNoticeAfterPaint(root?: ParentNode) {
  requestAnimationFrame(() => scrollToFirstBlockingNotice(root));
}
